import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/check_ring.svg'


const _withScopeId = n => (_pushScopeId("data-v-4e245021"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confirm-modal d-flex align-items-center justify-content-center" }
const _hoisted_2 = { class: "text-center mt-4 mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "d-block icon my-3"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  size: "32",
  alt: "Success"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 4,
  class: "d-flex flex-column flex-md-row align-items-center justify-content-center gap-3"
}
const _hoisted_7 = {
  key: 5,
  class: "d-flex align-items-center justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.icon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.title)
        ? (_openBlock(), _createBlock(_component_AsahiTypography, {
            key: 1,
            type: "headline-1",
            class: "d-block mt-3 mb-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.message)
        ? (_openBlock(), _createBlock(_component_AsahiTypography, {
            key: 2,
            type: "title-1-regular",
            class: "d-block mb-3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.message), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.submessage)
        ? (_openBlock(), _createBlock(_component_AsahiTypography, {
            key: 3,
            type: "title-1-bold",
            class: "d-block mb-3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.submessage), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.cancel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createVNode(_component_AsahiButton, {
                type: "primary",
                onClick: _cache[0] || (_cache[0] = () => _ctx.onConfirm()),
                class: "mt-4 ms-sm-2",
                style: {"width":"150px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.confirm), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_AsahiButton, {
                type: "secondary",
                onClick: _cache[1] || (_cache[1] = () => _ctx.onCancel()),
                class: "mt-4 me-sm-2",
                style: {"width":"150px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.cancel), 1)
                ]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_AsahiButton, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = () => _ctx.onConfirm()),
              class: "mt-4",
              style: {"width":"150px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.confirm), 1)
              ]),
              _: 1
            })
          ]))
    ])
  ]))
}